import { BulkMarkReviewedScreen } from "@/features/patients/features/overview/table/bulk/BulkMarkReviewedScreen";
import { patientsBulkActionBreadcrumbs } from "@/features/patients/features/overview/table/bulk/bulkNav";
import { parseBulkDiaryIdsSearch } from "@/features/patients/features/overview/table/bulk/bulkSearch";
import { useBulkDiaryIds } from "@/features/patients/features/overview/table/bulk/useBulkDiaryIds";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";

function BulkReviewedRoute() {
    const search = Route.useSearch();
    const diaryIds = useBulkDiaryIds(search.diaryIds ?? []);

    h.useNav(
        diaryIds.length > 0
            ? patientsBulkActionBreadcrumbs({
                  action: "reviewed",
                  diaryIds,
                  search: search as Record<string, unknown>,
              })
            : undefined
    );

    if (diaryIds.length === 0) return null;
    return <BulkMarkReviewedScreen diaryIds={diaryIds} />;
}

export const Route = createFileRoute("/_app/patients/bulk/reviewed")({
    validateSearch: (search: Record<string, unknown>) => parseBulkDiaryIdsSearch(search),
    component: BulkReviewedRoute,
});
